class PusherManager {

    pusherchannel;

    setPusherChannel = (pusherchannel) => {
        this.pusherchannel = pusherchannel
    }
}

export default new PusherManager()